import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import type { ActionContext } from 'js/lib/ActionContext';

/**
 * @deprecated
 * preferably, use the useFluxibleStore, useFluxibleActions hooks instead.
 */
export const withFluxibleContextAsProps =
  <P extends ActionContext>() =>
  (WrappedComponent: React.ComponentType<P>) => {
    return class Wrapper extends React.Component<P> {
      static displayName = `withFluxibleContextAsProps(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
      })`;

      static contextTypes = {
        executeAction: PropTypes.func,
      };

      declare context: LegacyContextType<typeof Wrapper.contextTypes>;

      render() {
        const { executeAction } = this.context;
        return <WrappedComponent {...this.props} executeAction={executeAction} />;
      }
    };
  };

export default withFluxibleContextAsProps;
